import {
  keepPreviousData,
  useQuery,
  type UseQueryOptions,
} from '@tanstack/react-query'
import {
  listJetAssignments,
  type ListJetAssignmentsRequest,
} from 'api/admin/jet/listJetAssignments'
import { jetKeys } from './keys'

type QueryData = Awaited<ReturnType<typeof listJetAssignments>>
type QueryKey = ReturnType<typeof jetKeys.assignmentsList>

type UseJetAssignmentsQueryOptions = Partial<
  UseQueryOptions<QueryData, Error, QueryData, QueryKey>
>

// Fetches a single keyset page (the cursor is baked into `params`). Prev/Next is
// driven by the caller swapping the cursor; `keepPreviousData` keeps the current
// page visible while the next one loads instead of flashing empty.
export const useJetAssignmentsQuery = (
  params: ListJetAssignmentsRequest,
  options: UseJetAssignmentsQueryOptions = {}
) => {
  return useQuery<QueryData, Error, QueryData, QueryKey>({
    ...options,
    queryKey: jetKeys.assignmentsList(params),
    queryFn: () => listJetAssignments(params),
    placeholderData: keepPreviousData,
  })
}
